import { render, staticRenderFns } from "./PartnerTable.vue?vue&type=template&id=6aa2ac97"
import script from "./PartnerTable.vue?vue&type=script&lang=js"
export * from "./PartnerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports